<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-md-0"
        >
          <label>Nama Dosen</label>
          <b-form-input 
            v-model="filter.nama_dosen"
            placeholder="Nama Dosen"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-md-0"
        >
          <label>Tanggal</label>
          <b-form-datepicker v-model="filter.tanggal"  locale="id"></b-form-datepicker>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-md-0"
        >
          <label>Waktu Ujian</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            v-model="filter.waktu_ujian_id"
            :options="waktuUjianOption.options"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Pilih Waktu Ujian"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mt-2"
        >
          <b-button variant="primary" @click="cari()">Cari</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  getJenisSidang,
  getStatusJadwalSidang,
  getWaktuUjian,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BFormDatepicker,
  },
  data() {
    return {
      filter: {},
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusJadwalOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Jadwal Sidang --' },
        ],
      },
      waktuUjianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
      getWaktuUjian()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.waktuUjianOption.options.push({
            label: element.nama,
            value: element.uuid,
          })
        })
      }
      })
      .catch(error => console.log(error));
  },
  methods: {
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
